<template>
  <ValidationObserver
    ref="profileFormObserver"
    tag="form"
    class="column is-10-fullhd"
    @submit.prevent="validateProfileBeforeSubmit()"
  >
    <!-- Informações Básicas -->
    <section>
      <h3>Informações Básicas</h3>
      <hr>

      <!-- Nome -->
      <span class="columns mt-8">
        <validation-provider
          rules="required|alpha_spaces"
          name="Nome"
          class="column is-12 is-half-desktop input-name"
          v-slot="{ errors }"
        >
          <b-field
            label="Nome"
            :type="{'is-danger': errors[0]}"
            :message="errors[0]"
          >
            <b-input
              v-model="userProfile.name"
              placeholder="NOME"
            />
          </b-field>
        </validation-provider>

        <!-- Sobrenome -->
        <validation-provider
          rules="required|alpha_spaces"
          name="Sobrenome"
          class="column is-12 is-half-desktop input-surname"
          v-slot="{ errors }"
        >
          <b-field
            label="Sobrenome"
            :type="{'is-danger': errors[0]}"
            :message="errors[0]"
          >
            <b-input
              v-model="userProfile.lastName"
              placeholder="SOBRENOME"
            />
          </b-field>
        </validation-provider>
      </span>

      <!-- Email -->
      <span class="columns mt-2">
        <validation-provider
          rules="required|email"
          name="Email"
          class="column is-12 is-half-desktop input-email"
          v-slot="{ errors }"
        >
          <b-field
            label="Email"
            :type="{'is-danger': errors[0]}"
            :message="errors[0]"
          >
            <b-input
              v-model="userProfile.email"
              placeholder="EMAIL"
            />
          </b-field>
        </validation-provider>
      </span>
    </section>

    <!-- Action Buttons -->

    <b-button
      class="ml-4"
      type="is-primary"
      native-type="submit"
    >
      Salvar
    </b-button>

  </ValidationObserver>
</template>

<script>
import { mapState } from 'vuex'
import { ValidationProvider, ValidationObserver } from 'vee-validate'

const DEBUG = process.env.NODE_ENV === 'development'

export default {
  components: {
    ValidationProvider,
    ValidationObserver
  },

  data () {
    return {
      performingRequest: false
    }
  },

  computed: {
    ...mapState([
      'userProfile',
      'currentUser'
    ])
  },

  methods: {
    async validateProfileBeforeSubmit () {
      const isValid =
        await this
          .$refs
          .profileFormObserver
          .validate()

      if (!isValid) {
        this
          .$toasted
          .error('Não foi possível salvar as alterações. Verifique os dados e tente novamente')
        return
      }

      try {
        this
          .$store
          .dispatch('updateProfile', this.userProfile)
      } catch (error) {
        DEBUG && console.error(error)
      }
    }
  }
}
</script>
